<template>
  <validation-provider
    ref="observer"
    v-slot="{ errors, changed }"
    rules="required"
  >
    <label class="data-label mb-0">{{ label }}:</label>

    <div class="d-flex">
      <input
        v-if="disabled"
        class="form-control w-15"
        disabled
        :value="value"
      />
      <custom-input
        v-else
        v-model="model"
        custom-error-msg="El NPI es requerido."
        class="w-15"
        :error="errors[0] && changed"
        @keypress="save"
      />

      <div class="ml-2">
        <div v-if="editing">
          <button
            v-if="canCancel && value"
            class="btn btn-outline-danger mr-2"
            type="button"
            variant="outline-danger mr-2"
            @click="cancel"
          >
            <i class="fas fa-times-circle" />
          </button>

          <button
            class="btn btn-success"
            :disabled="!!errors?.length || value == model"
            type="button"
            @click="save"
          >
            <i class="fas fa-save " />
          </button>
        </div>
        <button
          v-else
          class="btn btn-outline-success"
          type="button"
          @click="edit"
        >
          <i class="fas fa-edit " />
        </button>
      </div>
    </div>
  </validation-provider>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';

export default {
  name: 'Npi',
  components: {
    SectionTitle,
    CustomInput,
  },
  props: {
    value: {
      type: String,
      default: () => null,
    },
    label: {
      type: String,
      default: () => 'NPI',
    },
  },
  data() {
    return {
      editing: false,
      canCancel: false,
      model: null,
    };
  },
  computed: {
    disabled() {
      return !this.editing && this.value;
    },
  },
  methods: {
    edit() {
      this.editing = true;
      this.canCancel = true;
    },
    cancel() {
      this.model = this.value;
      this.editing = false;
    },
    async save() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;

      const callback = () => (this.editing = false);
      this.$emit('save', this.model, callback);
    },
  },
  mounted() {
    if (this.value) this.model = this.value;
    else this.editing = true;
  },
};
</script>

<style scoped></style>
